import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const i = ({ width: r = 20, height: t = 20, className: e, style: n }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    width: r,
    height: t,
    className: e,
    style: n,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o.jsx("path", { d: "M5 5H11.6667C12.3297 5 12.9656 5.26339 13.4344 5.73223C13.9033 6.20107 14.1667 6.83696 14.1667 7.5C14.1667 8.16304 13.9033 8.79893 13.4344 9.26777C12.9656 9.73661 12.3297 10 11.6667 10C12.3297 10 12.9656 10.2634 13.4344 10.7322C13.9033 11.2011 14.1667 11.837 14.1667 12.5C14.1667 13.163 13.9033 13.7989 13.4344 14.2678C12.9656 14.7366 12.3297 15 11.6667 15H5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M6.66675 5V15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M6.66675 10H11.6667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M7.5 2.5V5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M10.8333 2.5V5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M7.5 15V17.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M10.8333 15V17.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ]
  }
);
export {
  i as CryptoIcon
};
